import { render, staticRenderFns } from "./PaymentMethodView.vue?vue&type=template&id=c0cf9c7a"
import script from "./PaymentMethodView.vue?vue&type=script&lang=js"
export * from "./PaymentMethodView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports